"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMixinDeclarations = exports.applyMixin = exports.removeMixin = exports.parseMixinValue = void 0;
var core_1 = require("@stylable/core");
var buildMixin = function (mixins) { return mixins.join(', ') || undefined; };
var parseMixinValue = function (value) { return (value ? value.split(',').map(function (name) { return name.trim(); }) : []); };
exports.parseMixinValue = parseMixinValue;
function removeMixin(name, mixins) {
    if (!mixins) {
        return undefined;
    }
    var mixinList = (0, exports.parseMixinValue)(mixins);
    var nameIndex = mixinList.findIndex(function (mixin) { return mixin === name; });
    if (nameIndex !== -1) {
        mixinList.splice(nameIndex, 1);
    }
    return buildMixin(mixinList);
}
exports.removeMixin = removeMixin;
function applyMixin(name, mixins) {
    if (!mixins) {
        return "".concat(name);
    }
    var mixinList = (0, exports.parseMixinValue)(removeMixin(name, mixins));
    mixinList.push(name);
    return buildMixin(mixinList);
}
exports.applyMixin = applyMixin;
// TODO: this function actually finds the first rule that contains a class in the first chunk with specific name
// remove usage of createSubsetAst and find the rule via walk
function getMixinDeclarations(sheet, name) {
    var mixinSubset = (0, core_1.createSubsetAst)(sheet.AST, ".".concat(name));
    if (!mixinSubset.nodes || mixinSubset.nodes.length === 0) {
        return [];
    }
    return mixinSubset.nodes[0].nodes || []; // TODO: eval all values here or in controller?
}
exports.getMixinDeclarations = getMixinDeclarations;
//# sourceMappingURL=stylable-mixin.js.map